import {
  FILTER_OPTIONS,
  resolveSearchQuery,
  searchWithWordDropFallback,
  tokenizeSearchText,
} from "@/utils/search/tokenSearch";
import MiniSearch from "minisearch";

export { FILTER_OPTIONS, resolveSearchQuery, searchWithWordDropFallback, tokenizeSearchText };

const MIN_PREFIX_LENGTH = 3;

// Only the last word may still be mid-typing, so only it prefix-matches, and only once it's long enough.
function isPrefixEligible(term: string, index: number, terms: string[]): boolean {
  return index === terms.length - 1 && term.length >= MIN_PREFIX_LENGTH;
}

export const HIGHLIGHT_OPTIONS = { prefix: isPrefixEligible } as const;

export function buildSingleDocumentIndex(text: string): MiniSearch {
  const index = new MiniSearch({ fields: ["text"], tokenize: tokenizeSearchText });
  index.add({ id: "0", text });
  return index;
}

export interface HighlightWord {
  text: string;
  isPrefixMatch: boolean;
}

/**
 * Replaces each MiniSearch-matched word with whichever query word is a prefix
 * of it, so highlighting shows only the characters actually typed rather than
 * the whole resolved word (e.g. "nec" matching "necklace" highlights just "nec").
 * Flags whether the highlight word is a prefix or an exact match so callers can
 * require a trailing word boundary only for exact matches.
 */
export function toHighlightWords(matchedTerms: string[], resolvedQuery: string): HighlightWord[] {
  const queryTokens = tokenizeSearchText(resolvedQuery);
  return matchedTerms.map((matchedTerm) => {
    const prefixToken = queryTokens.find(
      (token) => token.length < matchedTerm.length && matchedTerm.startsWith(token)
    );
    if (prefixToken) return { text: prefixToken, isPrefixMatch: true };
    return { text: matchedTerm, isPrefixMatch: false };
  });
}
